import ReactGA4 from "react-ga4";

export function sendGA4Event(category: string, action: string) {
  if (!ReactGA4.isInitialized) {
    console.log("GA4 is not initialized");
  }
  ReactGA4.event({ category, action });
}

export function sendGA4PageView(page: string) {
  if (!ReactGA4.isInitialized) {
    console.log("GA4 is not initialized");
  }
  ReactGA4.send({ hitType: "pageview", page });
}
